export default "__VITE_ASSET__DKRobAnn__"